import { render, staticRenderFns } from "./PostListItemSmall.vue?vue&type=template&id=6d1343d0&"
import script from "./PostListItemSmall.vue?vue&type=script&lang=js&"
export * from "./PostListItemSmall.vue?vue&type=script&lang=js&"
import style0 from "./PostListItemSmall.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports